import { useMemo } from "react"

import Table from "components/table/Table"

import {
  mapTemperatureRuleThermostatsToRows,
  TemperatureRuleThermostat,
  temperatureRuleThermostatHeaderCells,
} from "./temperatureRuleThermostats"

import styles from "./index.module.scss"

interface TemperatureRuleThermostatsTabProps {
  thermostats: TemperatureRuleThermostat[]
  selectedThermostatIds: number[]
  onToggleThermostat: (thermostatId: number) => void
  onToggleAllThermostats: () => void
  onClearSelection: () => void
  onActionClick: (nextIsActive: boolean) => void
}

export const TemperatureRuleThermostatsTab = ({
  thermostats,
  selectedThermostatIds,
  onToggleThermostat,
  onToggleAllThermostats,
  onClearSelection,
  onActionClick,
}: TemperatureRuleThermostatsTabProps) => {
  const tableData = useMemo(() => mapTemperatureRuleThermostatsToRows(thermostats), [thermostats])
  const selectedThermostats = useMemo(
    () => thermostats.filter(thermostat => selectedThermostatIds.includes(thermostat.id)),
    [selectedThermostatIds, thermostats],
  )
  const selectedThermostatSnValues = selectedThermostats.map(thermostat => thermostat.thermostatSn)
  const selectedThermostatLabel = selectedThermostatSnValues.join(", ")
  const isHeaderChecked = thermostats.length > 0 && selectedThermostatIds.length === thermostats.length
  const actionButtonsDisabled = selectedThermostatIds.length === 0

  return (
    <div className={styles.thermostatsTab}>
      <div className={styles.thermostatActions}>
        <button
          type="button"
          className={styles.thermostatActionButton}
          data-action="activate"
          onClick={() => onActionClick(true)}
          disabled={actionButtonsDisabled}
        >
          Activate
        </button>
        <button
          type="button"
          className={styles.thermostatActionButton}
          data-action="deactivate"
          onClick={() => onActionClick(false)}
          disabled={actionButtonsDisabled}
        >
          Deactivate
        </button>
      </div>

      {selectedThermostatSnValues.length > 0 && (
        <div className={styles.selectedFilters}>
          <p className={styles.selectedFiltersLabel}>Selected filter(s)</p>
          <p className={styles.grayDivider}>{"|"}</p>
          <div className={styles.selectedFiltersTags}>
            <span className={styles.selectedFilterTag}>
              <span className={styles.selectedFilterTagLabel}>Thermostat ID:</span>
              <span className={styles.selectedFilterTagValues}>{selectedThermostatLabel}</span>
            </span>
            <button type="button" className={styles.clearSelectionButton} onClick={onClearSelection}>
              Clear
            </button>
          </div>
        </div>
      )}

      <div className={styles.thermostatsTableScroll}>
        <Table
          headerCells={temperatureRuleThermostatHeaderCells}
          data={tableData}
          fitContainer={true}
          currentItemIDs={selectedThermostatIds}
          isHeaderChecked={isHeaderChecked}
          onCheckboxChange={onToggleThermostat}
          onHeaderCheckboxChange={onToggleAllThermostats}
        />
      </div>
    </div>
  )
}
